import mushroom from 'mushroomjs';

mushroom._defineAsyncResource({name:"mushroom_user",actions:{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},views:{}});
mushroom._defineAsyncResource({name:"application",actions:{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},views:{}});
mushroom._defineAsyncResource({name:"survey",actions:{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_generateHashCode":{},"_raw_http_method_validateHashCode":{}},views:{}});
mushroom._defineAsyncResource({name:"survey_item",actions:{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{},"createMany":{},"updatePartially":{},"deleteOne":{}},views:{}});
mushroom._defineAsyncResource({name:"survey_result",actions:{"findMany":{"clientCache":false},"findById":{"clientCache":false},"createOne":{},"updatePartially":{}},views:{}});
mushroom._defineAsyncResource({name:"survey_callback",actions:{"findMany":{"clientCache":false},"findById":{"clientCache":false}},views:{}});
mushroom._defineAsyncResource({name:"survey_result",actions:{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},views:{"rptSurveyResult":{},"rptSurveyResultText":{}}});
function toQueryString(obj, path) {
    if (obj === null || obj === undefined || typeof obj == "function")
        return "";

    if (typeof obj == "string" || typeof obj == "number" || typeof obj == "boolean")
        return obj;

    if (Array.isArray(obj))
        return obj.map(function (item) {
            return toQueryString(item, path);
        }).join(",");

    var arr = [];
    for (var m in obj) {
        if (!obj.hasOwnProperty(m))
            continue;

        var key = (path ? path : "") + m;
        arr.push(key + "=" + toQueryString(obj[m], key));
    }
    return arr.join("&");
}

mushroom.survey.generateHashCodeAsync = mushroom.__createAsyncRestFunction({
  name: "survey.generateHashCodeAsync", // Identify your method
  method: "POST", // GET if your request doesn't have body otherwise POST
  headers: {
    "X-HTTP-Method-Override": "generateHashCode" // real method
  },
  blankBody: false, // true if your request doesn't have body
  url: mushroom._fnGetRootApiUrl() + "surveys/generateHashCode"
});

mushroom.$using(window.MyConfig.hostApi);
export default mushroom;
